import React from "react";
import { FormattedNumber } from "react-intl";

const Weight = props => {
  if (props.value === null) {
    return <span>0kg</span>;
  }

  return (
    <span>
      <FormattedNumber
        style="decimal"
        value={props.value}
        minimumFractionDigits={1}
        maximumFractionDigits={3}
      />
      kg
    </span>
  );
};

export default Weight;
